import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FaceMonocleIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 15C11.3428 15 14.1383 12.6569 14.8337 9.52344C14.4317 9.66907 14.031 9.69183 13.6572 9.63098C12.9941 9.52307 12.453 9.16016 12.1465 8.85358L11.7383 8.44537C11.2478 8.79462 10.6479 9 10 9C8.34314 9 7 7.65686 7 6C7 4.34314 8.34314 3 10 3C11.6569 3 13 4.34314 13 6C13 6.64789 12.7946 7.24786 12.4454 7.73828L12.8535 8.14642C13.047 8.33984 13.4059 8.57697 13.8178 8.64398C14.1587 8.69946 14.5652 8.64545 14.9943 8.28613C14.9981 8.19122 15 8.09583 15 8C15 4.13403 11.866 1 8 1C4.134 1 1 4.13403 1 8C1 11.866 4.134 15 8 15ZM5 5C4.44772 5 4 5.44769 4 6C4 6.55231 4.44772 7 5 7C5.55228 7 6 6.55231 6 6C6 5.44769 5.55228 5 5 5ZM9.10001 11.95C8.8515 12.2814 8.38138 12.3486 8.05002 12.1L7.49225 11.6817C7.08762 11.3782 6.58524 11.2659 6.10767 11.3482C5.69946 11.4185 5.22977 11.3447 5.00003 11C4.77026 10.6554 4.86218 10.1802 5.24976 10.034C6.28879 9.64203 7.47693 9.79517 8.39224 10.4817L8.95001 10.9C9.2814 11.1486 9.34854 11.6187 9.10001 11.95Z"
			/>
			<path
				fill="currentColor"
				d="M9 5C8.44772 5 8 5.44769 8 6C8 6.55231 8.44772 7 9 7C9.55228 7 10 6.55231 10 6C10 5.44769 9.55228 5 9 5Z"
			/>
		</svg>
	),
)
